import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useStore } from '@/contexts/StoreContext';
import { partnerService, type MyPartner } from '@/lib/services/partner.service';

/**
 * O cadastro de parceiro do jogador logado, ou `null` se ele não é parceiro.
 *
 * Decide se o menu mostra "Área do parceiro". Esconder o menu é só
 * conveniência: quem garante que só o parceiro vê os dados é a API.
 */
export function useMyPartner() {
  const { store } = useStore();
  const { isAuthenticated, user } = useAuth();
  const [partner, setPartner] = useState<MyPartner | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!store?.id || !isAuthenticated) {
      setPartner(null);
      return;
    }

    let cancelado = false;
    setLoading(true);
    partnerService
      .getMe(store.id)
      .then((p) => {
        if (cancelado) return;
        setPartner(p);
        setError(false);
      })
      .catch(() => !cancelado && setError(true))
      .finally(() => !cancelado && setLoading(false));

    return () => {
      cancelado = true;
    };
  }, [store?.id, isAuthenticated, user?.id]);

  return { partner, isPartner: partner !== null, loading, error };
}
